export const resolveColorVariant = (variant, theme) => {
  const variantMap = {
    info: theme.tokens.ComponentFlagIconInfoColor,
    error: theme.tokens.ComponentFlagIconErrorColor,
    success: theme.tokens.ComponentFlagIconSuccessColor,
    caution: theme.tokens.ComponentFlagIconCautionColor,
    light: theme.tokens.ComponentFlagIconDefaultColor,
    white: theme.tokens.ComponentFlagIconDefaultColor,
    dark: ''
  };
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return variantMap[variant];
};
export const resolveBgColorVariant = (variant, theme) => {
  const variantMap = {
    info: theme.tokens.ComponentFlagVariantInfoBg,
    error: theme.tokens.ComponentFlagVariantErrorBg,
    success: theme.tokens.ComponentFlagVariantSuccessBg,
    caution: theme.tokens.ComponentFlagVariantCautionBg,
    light: theme.tokens.ComponentFlagVariantLightBg,
    white: theme.tokens.ComponentFlagVariantWhiteBg,
    dark: theme.tokens.ComponentFlagVariantDarkBg
  };
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return variantMap[variant];
};